// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__mHsSq","inputWrap":"styles_inputWrap__ueyZd","input":"styles_input__2AIVL"};